import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=bd4f56bc&scoped=true&lang=pug&"
import script from "./Popup.vue?vue&type=script&lang=js&"
export * from "./Popup.vue?vue&type=script&lang=js&"
import style0 from "./Popup.vue?vue&type=style&index=0&id=bd4f56bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4f56bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd4f56bc')) {
      api.createRecord('bd4f56bc', component.options)
    } else {
      api.reload('bd4f56bc', component.options)
    }
    module.hot.accept("./Popup.vue?vue&type=template&id=bd4f56bc&scoped=true&lang=pug&", function () {
      api.rerender('bd4f56bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/older_adult/Popup.vue"
export default component.exports